/*
 * TC 리뷰 — 무한 롤링 + 클릭 팝업(Swiper)
 * 각 .tc-review 단위로 동작. Swiper 전역 준비될 때까지 대기.
 */
(function () {
  function waitSwiper(cb) {
    if (typeof Swiper === 'undefined') { setTimeout(function () { waitSwiper(cb); }, 50); return; }
    cb();
  }

  function initReview(reviewWrap) {
    if (reviewWrap.dataset.reviewInit === '1') return;
    reviewWrap.dataset.reviewInit = '1';

    var list = reviewWrap.querySelector('.tc-review-list');
    var track = list ? list.querySelector('.tc-review-track') : null;

    // 무한 롤링: 트랙 복제 + 폭 기반 속도
    if (list && track) {
      var PX_PER_SEC = 60;
      var clone = track.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      clone.querySelectorAll('a').forEach(function (a) { a.setAttribute('tabindex', '-1'); });
      list.appendChild(clone);

      var applyDuration = function () {
        var w = track.getBoundingClientRect().width;
        if (w) list.style.animationDuration = (w / PX_PER_SEC) + 's';
      };
      if (document.readyState === 'complete') applyDuration();
      else window.addEventListener('load', applyDuration);
      window.addEventListener('resize', applyDuration);
    }

    var popup = reviewWrap.querySelector('.tc-review-layer-popup');
    if (!popup || !track) return;
    waitSwiper(function () { initPopup(reviewWrap, popup, track); });
  }

  function initPopup(reviewWrap, popup, track) {
    var popupInner = popup.querySelector('.tc-review-layer-popup-inner');
    var titleEl = popup.querySelector('.tc-review-lp-title');
    var labelEl = popup.querySelector('.tc-review-lp-label');
    var closeBtn = popup.querySelector('.tc-review-lp-close-btn');
    var lpEl = popup.querySelector('.tc-review-lp');
    if (!popupInner || !titleEl || !labelEl || !lpEl) return;
    var lpWrapper = lpEl.querySelector('.swiper-wrapper');
    if (!lpWrapper) return;

    // 원본 트랙 기준 데이터(복제본 제외)
    var origItems = Array.prototype.slice.call(track.querySelectorAll('.tc-review-item'));
    var reviewData = origItems.map(function (item) {
      var img = item.querySelector('img');
      var span = item.querySelector('span');
      return {
        title: item.dataset.title || '',
        label: span ? span.textContent.trim() : '',
        href: item.dataset.href || '#none',
        img: img ? img.getAttribute('src') : '',
      };
    });
    var N = reviewData.length;
    var lpSwiper = null;
    var savedY = 0;

    function buildSlides(startIdx) {
      lpWrapper.innerHTML = '';
      var ordered = reviewData.slice(startIdx).concat(reviewData.slice(0, startIdx));
      ordered.forEach(function (data) {
        var slide = document.createElement('div');
        slide.className = 'swiper-slide';
        slide.dataset.href = data.href;
        slide.dataset.title = data.title;
        slide.dataset.label = data.label;
        var inner = document.createElement('div');
        inner.className = 'tc-review-lp-item';
        var img = document.createElement('img');
        img.src = data.img;
        img.alt = data.label;
        inner.appendChild(img);
        slide.appendChild(inner);
        lpWrapper.appendChild(slide);
      });
    }

    function updateText() {
      if (!lpSwiper) return;
      var slides = lpWrapper.querySelectorAll('.swiper-slide:not(.swiper-slide-duplicate)');
      var active = slides[lpSwiper.realIndex];
      if (!active) return;
      titleEl.textContent = active.dataset.title || '';
      labelEl.textContent = active.dataset.label || '';
    }

    function handleSlideClick(e) {
      if (lpSwiper && !lpSwiper.allowClick) return;
      var slide = e.target.closest('.swiper-slide');
      if (!slide || !slide.classList.contains('swiper-slide-active')) return;
      var href = slide.dataset.href;
      if (href && href !== '#none') window.location.href = href;
    }

    function openPopup(startIdx) {
      buildSlides(startIdx);
      savedY = window.scrollY;
      document.body.style.top = '-' + savedY + 'px';
      document.body.classList.add('s-p');
      popup.style.display = 'block';
      var count = lpWrapper.querySelectorAll('.swiper-slide').length;
      lpSwiper = new Swiper(lpEl, { loop: count > 1, on: { slideChange: updateText } });
      updateText();
      lpWrapper.addEventListener('click', handleSlideClick);
    }

    function closePopup() {
      if (popup.style.display !== 'block') return;
      if (lpSwiper) { lpSwiper.destroy(true, true); lpSwiper = null; }
      lpWrapper.removeEventListener('click', handleSlideClick);
      lpWrapper.innerHTML = '';
      popup.style.display = 'none';
      document.body.classList.remove('s-p');
      document.body.style.top = '';
      window.scrollTo(0, savedY);
    }

    // 모든 아이템(복제 포함) 클릭 → 원본 인덱스로 팝업
    var allItems = Array.prototype.slice.call(reviewWrap.querySelectorAll('.tc-review-item'));
    allItems.forEach(function (item, j) {
      item.addEventListener('click', function (e) {
        e.preventDefault();
        openPopup(N ? j % N : 0);
      });
    });

    if (closeBtn) closeBtn.addEventListener('click', closePopup);

    popup.addEventListener('click', function (e) {
      var navBtn = e.target.closest('.tc-p-next-btn, .tc-p-prev-btn');
      if (navBtn) {
        e.preventDefault();
        e.stopPropagation();
        if (!lpSwiper) return;
        if (navBtn.classList.contains('tc-p-next-btn')) lpSwiper.slideNext();
        else lpSwiper.slidePrev();
        return;
      }
      if (popupInner && !popupInner.contains(e.target)) {
        e.stopPropagation();
        closePopup();
      }
    }, true);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closePopup();
    });
  }

  function initAll() {
    document.querySelectorAll('.tc-review').forEach(initReview);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target && e.target.querySelector ? e.target.querySelector('.tc-review') : null;
    if (el) { el.dataset.reviewInit = ''; initReview(el); } else { initAll(); }
  });
})();
